module.exports = __webpack_public_path__ + "img/slide3.a09720ee.jpg";